import RxQuery from 'utils/api/rxQuery/rxQuery';
import endpoints from 'utils/api/endpoints';

const eCommerce = () => new RxQuery('eCommerce');

// export const getGroup = (category: types.services.category) => {
//   return eCommerce().setEndpoint(endpoints.eCommerce.getGroup(category));
// };

export const getGroupContent = (groupID: string) => {
	return eCommerce().setEndpoint(endpoints.eCommerce.services.getGroupContent(groupID));
};

export const getContentBySearchTerm = (searchTerm: string) => {
	return eCommerce().setEndpoint(endpoints.eCommerce.services.getContentBySearchTerm(searchTerm));
};

export const getContentByUniqueID = (uniqueID: string) => {
	return eCommerce().setEndpoint(endpoints.eCommerce.services.getContentByUniqueID(uniqueID));
};

export const getPackages = (group: types.ecommerce.PackageGroup, type: types.ecommerce.PackageType) => {
	return eCommerce()
		.setEndpoint(endpoints.eCommerce.services.getByGroupAndType(group, type))
		.setType('packages');
};

export const getContentByPartNumber = (partNumber: string) => {
	return eCommerce().setEndpoint(endpoints.eCommerce.services.getContentByPartNumber(partNumber));
};
//
// export const getRecommendedServices = () => {
//   return eCommerce().setEndpoint(endpoints.eCommerce.getRecommendedServices());
// };
//
// export const getInstantRecommendedServices = () => {
//   return eCommerce().setEndpoint(
//     endpoints.eCommerce.getInstantRecommendedServices()
//   );
// };
